<template>
  <div class="p-4 min-h-[calc(100vh-2.5rem)]">
    <router-view v-slot="slotProps">
      <transition name="route" mode="out-in">
        <component :is="slotProps.Component"></component>
      </transition>
    </router-view>
  </div>
</template>
<script>
export default {
  name: "Appmain"
};
</script>
<style scoped>
.route-enter-from,
.route-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
.route-enter-active,
.route-leave-active {
  transition: all 0.5s ease;
}
.route-enter-to,
.route-leave-from {
  opacity: 1;
  transform: translateX(0);
}


</style>
